import script from "./HostDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./HostDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./HostDisplay.vue?vue&type=style&index=0&id=84dfd806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84dfd806"]])

export default __exports__